module.exports = __webpack_public_path__ + "02047815471efe7cde250ab6bb5de18c.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/schalen/Ruoff_091122_0141_V_w.jpg
// module id = 378
// module chunks = 0